<template>
  <section id="engMainInfo" class="msection">
    <div class="container">
      <div class="info-content-img" style="text-align: center;">
        <img src="@/assets/img/main/dhfesta_info_0401.jpg" alt="Korea Shopping Festa Info" style="width: 100%; max-width: 1300px; margin: 0 auto; display: block;" />
      </div>
    </div>

    <!-- 소상공인 온라인 기획전 -->
    <div class="gray-bg" v-if="mutualDisEventList.length > 0">
      <div class="in-container">
        <div class="inFlexBox">
          <h2>소상공인<br> 온라인 기획전</h2>
          <div class="shop-list-wrap">
            <ul class="shop-list">
              <li v-for="item in mutualDisEventList" :key="item.name" class="shop-list-li">
                <a :href="item.link" target="_blank" rel="noopener noreferrer" class="shop-list-item" @click="handleMutualEventClick($event, item.beforeEvent, item.link)" draggable="false">
                  <div class="shop-list-item-img">
                    <i class="icon">
                      <img :src="require('@/assets/img/mutual/' + item.img)" alt="" draggable="false">
                    </i>
                  </div>
                  <span v-html="item.name"></span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- //소상공인 온라인 기획전 -->

    <!-- 준비중 알림 -->
    <common-alert />
  </section>
</template>

<script>
import { MUT_SHOW_ALERT } from "@/store/_mut_consts";
import CommonAlert from "@/components/common/CommonAlert";

export default {
  name: "EngMainInfoVideo",
  components: { CommonAlert },
  data: () => ({
    mutualDisEventList: [
      // {name: "Hyundai Ezwel", link: "https://shopping.naver.com/festa/onsale/6859042b8460fb3cc07ea0c5?tr=prosol", img: "01_new.png", beforeEvent: new Date('2026-04-11T00:00:00') },
      {name: "Epost.Mall", link: "https://www.lotteon.com/m/display/planV2/planDetail/120320", img: "02_new.png", beforeEvent: new Date('2026-04-11T00:00:00') },
      {name: "Oasis", link: "http://rpp.gmarket.co.kr/?exhib=249148", img: "03_new.png", beforeEvent: new Date('2026-04-11T00:00:00') },
      {name: "H.Mall", link: "https://www.grip.show/w/event/with_on-market", img: "04_new.png", beforeEvent: new Date('2026-04-11T00:00:00') },
      {name: "Zigzag", link: "https://ssg.com/plan/planShop.ssg?dispCmptId=6000465146", img: "05_new.png", beforeEvent: new Date('2026-04-11T00:00:00') },
      {name: "Gmarket", link: "https://www.skstoa.com/plan/event/detail/2024049628", img: "06_new.png", beforeEvent: new Date('2026-04-11T00:00:00') },
      {name: "Grip", link: "https://www.hmall.com/md/dpa/searchSpexSectItem?sectId=3123892", img: "13_new.png", beforeEvent: new Date('2026-04-11T00:00:00') },
      {name: "SK Stoa", link: "https://mall.epost.go.kr/fo/display/plnbefDspyNewView.do?plnbefId=10024768", img: "07_new.png", beforeEvent: new Date('2026-04-11T00:00:00') },
      {name: "LotteOn", link: "https://zigzag.kr/events/ae91e7f8-43a4-41b3-a6e1-3ffb3884096c", img: "08_new.png", beforeEvent: new Date('2026-04-11T00:00:00') },
      {name: "11st", link: "https://www.musinsa.com/campaign/25project_onlineshoppingmall", img: "09_new.png", beforeEvent: new Date('2026-04-11T00:00:00') },
      {name: "NS.Mall", link: "https://www.oasis.co.kr/event/2025/catSosang_1029", img: "10_new.png", beforeEvent: new Date('2026-04-11T00:00:00') },
      {name: "Hwahae", link: "https://www.oasis.co.kr/event/2025/catSosang_1029", img: "11_new.png", beforeEvent: new Date('2026-04-11T00:00:00') },
      {name: "SSG", link: "https://www.oasis.co.kr/event/2025/catSosang_1029", img: "12_new.png", beforeEvent: new Date('2026-04-11T00:00:00') },
      {name: "Kurly", link: "https://www.oasis.co.kr/event/2025/catSosang_1029", img: "14_new.png", beforeEvent: new Date('2026-04-11T00:00:00') },
      {name: "Talk Deal", link: "https://www.oasis.co.kr/event/2025/catSosang_1029", img: "15_new.png", beforeEvent: new Date('2026-04-11T00:00:00') },
    ],
  }),
  created() {},
  mounted() {},
  methods: {
    handleMutualEventClick(event, beforeEvent, link) {
      if (beforeEvent && new Date() < beforeEvent) {
        event.preventDefault();
        this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
          title: '준비 중입니다.',
          rightNow: true,
        });
      }
    },
  },
};
</script>

<style>
.gray-bg { padding:60px 0; width:100%; background-color:#F5F5F5; }
.gray-bg .in-container { margin:0 auto; padding: 0 24px; width:100%; max-width:1648px; }
.gray-bg .inFlexBox {display:flex; justify-content: space-between; align-items:center; gap:30px;}
.gray-bg .inFlexBox h2 {flex:0 0 194px; font-size:32px;}
.gray-bg .inFlexBox .shop-list-wrap {overflow-x:auto; overflow-y: hidden; padding-bottom: 4px;}
.gray-bg .inFlexBox .shop-list-wrap::-webkit-scrollbar {height: 4px;}
.gray-bg .inFlexBox .shop-list-wrap::-webkit-scrollbar-track {background-color: #E4E4E4; border-radius: 999px; }
.gray-bg .inFlexBox .shop-list-wrap::-webkit-scrollbar-thumb { background-color: #075D5D; border-radius: 999px; }
.gray-bg .inFlexBox .shop-list {display:flex; gap:43px;}
.gray-bg .inFlexBox .shop-list-li {min-width:66px;}
.gray-bg .inFlexBox .shop-list-li .shop-list-item > span {display:block; margin-top:6px; text-align: center; font-size:14px; color:#2d2d2d;}
@media(max-width:800px) {
  .gray-bg { padding:40px 0;}
  .gray-bg .inFlexBox {flex-direction: column; gap:16px;}
  .gray-bg .inFlexBox h2 {flex:initial; align-self:flex-start; font-size:20px;}
  .gray-bg .inFlexBox h2 br {display:none;}
  .gray-bg .inFlexBox .shop-list-wrap {width:100%;}
  .gray-bg .inFlexBox .shop-list {gap:24px;}
}
</style>
